// ─── ICON REGISTRY ────────────────────────────────────────────────────────
// BRAND.md §7: no emoji in UI. One Lucide glyph per concept, rendered via the
// npm `lucide-react` package (already a project dependency) — NOT the CDN
// `window.lucide` global the Claude Design project's Icon.jsx expects.
//
// Same pattern as the existing category map in src/lib/icons.js: a plain
// name -> component lookup, so src/components/ui/Icon.jsx can accept a
// string `name` prop (matching the design system's component API) while
// staying tree-shakeable and dependency-consistent with the rest of the app.
//
// Add entries here as emoji/ad-hoc glyphs are replaced across the app —
// never inline a one-off lucide-react import to sidestep this registry.

import {
  ShoppingCart, ShoppingBag, Minus, Plus, ChevronDown, ChevronLeft, ChevronRight,
  TriangleAlert, PackageOpen, RotateCcw, Search, Globe, LayoutDashboard, Package,
  Users, Store, ChartColumn, Settings, ArrowLeft, ArrowRight, ClipboardList,
  Image, User, Check, CheckCircle2, CreditCard, Landmark, Banknote, Link,
  Trash2, Building2, MessageCircle, Mail, Smartphone, Camera, Monitor, Phone,
  KeyRound, Ban, X, Undo2, Send, Sparkles, RefreshCw, Pencil, Lightbulb,
  PartyPopper, Upload, Megaphone, LogOut, FileText, TrendingUp, Lock,
  ExternalLink, Eye, EyeOff, Filter, Download, Printer, Truck, Wallet,
  MessageSquare, ArrowLeftRight, ClipboardCheck, AlertCircle, Info, Loader2,
  Receipt, MapPin, Zap, XCircle, Tag, Brain, FolderOpen, Clock, ArrowDownAZ,
  Trophy, Award, Share2, FileSpreadsheet, Home,
} from 'lucide-react';

export const ICONS = {
  ShoppingCart, ShoppingBag, Minus, Plus, ChevronDown, ChevronLeft, ChevronRight,
  TriangleAlert, PackageOpen, RotateCcw, Search, Globe, LayoutDashboard, Package,
  Users, Store, ChartColumn, Settings, ArrowLeft, ArrowRight, ClipboardList,
  Image, User, Check, CheckCircle2, CreditCard, Landmark, Banknote, Link,
  Trash2, Building2, MessageCircle, Mail, Smartphone, Camera, Monitor, Phone,
  KeyRound, Ban, X, Undo2, Send, Sparkles, RefreshCw, Pencil, Lightbulb,
  PartyPopper, Upload, Megaphone, LogOut, FileText, TrendingUp, Lock,
  ExternalLink, Eye, EyeOff, Filter, Download, Printer, Truck, Wallet,
  MessageSquare, ArrowLeftRight, ClipboardCheck, AlertCircle, Info, Loader2,
  Receipt, MapPin, Zap, XCircle, Tag, Brain, FolderOpen, Clock, ArrowDownAZ,
  Trophy, Award, Share2, FileSpreadsheet, Home,
};

export function iconByName(name) {
  return ICONS[name] || null;
}
